import { render } from "./LicensePlateView.vue?vue&type=template&id=528ba8bd&ts=true"
import script from "./LicensePlateView.vue?vue&type=script&lang=ts"
export * from "./LicensePlateView.vue?vue&type=script&lang=ts"

import "./LicensePlateView.vue?vue&type=style&index=0&id=528ba8bd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__